import { useLocation, useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { NAV_ITEMS } from './Sidebar'

export function BottomNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-white/10 bg-gray-950/95 backdrop-blur-xl">
      <div className="flex overflow-x-auto scrollbar-none">
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
          const isActive = path === '/' ? pathname === '/' : pathname.startsWith(path)
          return (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              className={cn(
                'flex shrink-0 flex-col items-center justify-center gap-0.5 py-2 px-3 min-w-[60px] transition-colors active:scale-95',
                isActive ? 'text-blue-400' : 'text-white/40 hover:text-white/70'
              )}
            >
              <Icon className={cn('h-5 w-5 shrink-0', isActive && 'scale-110 transition-transform')} />
              <span className={cn(
                'text-[9px] leading-tight font-medium whitespace-nowrap',
                isActive ? 'text-blue-400' : 'text-white/40'
              )}>
                {label}
              </span>
              {isActive && (
                <span className="absolute bottom-0 h-0.5 w-5 rounded-full bg-blue-400" />
              )}
            </button>
          )
        })}
      </div>
    </nav>
  )
}
